import React, { ReactNode } from 'react';
import { InfinitePagination } from '@funtech-int/rival';

import { ScrollSentinel } from '../ScrollSentinel/ScrollSentinel';

import { Grid, GridProps } from './Grid';
import styles from './InfiniteGrid.module.css';

interface InfiniteGridProps<T> extends Omit<GridProps<T>, 'children'> {
    pagination: InfinitePagination;
    hasMore?: boolean;
    orientation?: 'vertical' | 'horizontal';
    skeleton?: ReactNode;
}

export function InfiniteGrid<T>({
    items,
    renderItem,
    getKey,
    separateBy,
    renderSeparator,
    className,
    itemClassName,
    separatorClassName,
    pagination,
    hasMore = true,
    skeleton,
    orientation = 'vertical',
    title,
}: InfiniteGridProps<T>) {
    return (
        <Grid
            items={items}
            renderItem={renderItem}
            getKey={getKey}
            separateBy={separateBy}
            renderSeparator={renderSeparator}
            className={className}
            itemClassName={itemClassName}
            separatorClassName={separatorClassName}
            title={title}
        >
            {hasMore && (
                <ScrollSentinel
                    skeleton={skeleton}
                    pagination={pagination}
                    orientation={orientation}
                    direction="end"
                    className={styles.fullWidth}
                />
            )}
        </Grid>
    );
}
